import React from "react"

const QuickorderHead = ( ) => {
  return (
   <React.Fragment>
     <colgroup>
       <col width="30"/>
       <col width="100%"/>
       <col width="20%"/>
       <col width="10%"/>
       <col width="10%"/>
       <col width="10%"/>
       <col width="10%"/>
       <col width="10%"/>
       <col width="10%"/>
       <col width="10%"/>
     </colgroup>
     <thead>
     <tr>
       <th>&nbsp;</th>
       <th>{translate( "article" )}</th>
       <th>{translate("Preis/VE")}</th>
       <th>{translate( "total count" )}</th>
       <th>{translate( "sum" )}</th>
       {/*<th>{translate( "PU" )}</th>*/}
       <th style={{ textAlign: "right" }}>
           <div className="">{translate( "amount (VE)" )}</div>
       </th>
     </tr>
     </thead>
   </React.Fragment>
  )
}


export default QuickorderHead


// WEBPACK FOOTER //
// ./src/theme/hvz/components/Quickorder/QuickorderHead.js